<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <h3 class="my-4">Newsletter:</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table striped hover :items="items" :fields="fields">
            <template slot="excluir" slot-scope="data">
              <i
                @click="removeObj(data.item)"
                class="fas fa-trash-alt danger"
              ></i>
            </template>
            <template slot="timestamp" slot-scope="data">
              {{ data.item.timestamp | moment("DD/MM/YYYY hh:mm:ss") }}
            </template>
          </b-table>

          <div v-show="loading" class="loading-holder">
            <div class="loading-spinner"></div>
          </div>
        </b-col>
      </b-row>

      <v-pagination
        class="f-right mt-3"
        v-model="currentPage"
        :page-count="pages"
      ></v-pagination>
    </b-container>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import authentication from "../util/authentication";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import vPagination from "vue-plain-pagination";

export default {
  name: "Newsletter",
  data() {
    return {
      entity: {
        eng: "Newsletter",
        por: "Newsletter"
      },
      fields: [
        {
          key: "email",
          label: "Email",
          sortable: false
        },
        {
          key: "timestamp",
          label: "Data",
          sortable: false
        },
        "excluir"
      ],
      items: [],
      currentPage: 1,
      pages: 1,
      loading: true
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    vPagination
  },
  methods: {
    removeObj(obj) {
      if (
        confirm(
          `Tem certeza que deseja deletar a ${this.entity.por} "${obj.email}"`
        )
      ) {
        http
          .delete(`${this.entity.eng}/${obj.id}`, authentication.getHeaders())
          .then(response => {
            this.list();
          });
      }
    },
    list() {
      http
        .get(
          `${this.entity.eng}?page=${this.currentPage - 1}`,
          authentication.getHeaders()
        )
        .then(res => {
          this.items = res.data.list;
          this.pages = res.data.pages;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.list();
  },
  watch: {
    currentPage() {
      this.list();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Newsletter.vue